import axios from 'axios';
import { myShopApiStore } from '../Stores';

const ignoreOfflineForEndpoints = ['save-cookies-consent'];

axios.interceptors.response.use(
    response => {
        if (!myShopApiStore.isOnline) {
            myShopApiStore.isOnline = true;
            
            window.dispatchEvent(new Event('online'));
        }
        return response;
    },
    error => {
        const requestUrl = error?.config?.url || '';
        const shouldIgnore = ignoreOfflineForEndpoints.some(endpoint => requestUrl.includes(endpoint));
        
        if (!shouldIgnore && (!navigator.onLine || error.message === 'Network Error')) {
            myShopApiStore.isOnline = false;
            window.dispatchEvent(new Event('offline'));
        }
        return Promise.reject(error);
    }
);